import moment from "moment";
import { SqlString, sqlEmptyValue, stringifyForDisplay, wrapWithBrackets } from "../utils/export";
import { mongoEmptyValue, mongoFormatOp1, mongoFormatOp2 } from "../utils/mongoUtils";
import { spelFixList, spelEscape } from "../utils/spelUtils";
import { escapeRegExp } from "../utils/stuff";
import { getTitleInListValues } from "../utils/listValues";
var ctx = {
  utils: {
    SqlString: SqlString,
    moment: moment,
    mongoFormatOp1: mongoFormatOp1,
    mongoFormatOp2: mongoFormatOp2,
    mongoEmptyValue: mongoEmptyValue,
    escapeRegExp: escapeRegExp,
    sqlEmptyValue: sqlEmptyValue,
    stringifyForDisplay: stringifyForDisplay,
    getTitleInListValues: getTitleInListValues,
    spelEscape: spelEscape,
    spelFixList: spelFixList,
    wrapWithBrackets: wrapWithBrackets
  }
};
export default ctx;